<template>

  <div class="d-block w-100">
    <listado-acuerdos-lineas-tabla
      :getListaAcuerdosLineas="getListaAcuerdosLineas"
      :data="data"
    />
  </div>
</template>

<script>

import { mapState, mapActions } from "vuex";

import { getAcuerdosLineas, getListasAcuerdosBase } from "@/constants/lineas";

import ListadoAcuerdosLineasTabla from "../../../components/tablas/lineas/ListadoAcuerdosLineasTabla";

export default {
  components: {
    ListadoAcuerdosLineasTabla
},
  data() {
    return {
      data: [],
      fullData: [],
      lang: {
        lengthMenu: "Display _MENU_ records per page",
        zeroRecords: "No se encontraron registros coincidentes",
        info: "Mostrando página _PAGE_ de _PAGES_",
        infoEmpty: "No hay registros disponibles",
        infoFiltered: "(filtrado de _MAX_ registros totales)",
        search: "Buscar",
      },
    };
  },
  computed: {
    ...mapState(["token", "cargarTabla"]),
    ...mapState("lineas", ["dataDatatableTarifasAcuerdosLineas"]),
  },
  methods: {
    // Acciones de Vuexs
    ...mapActions([
      "AccionCambiar",
      "ActionSetLoading",
      "ActionSetCargarTabla",
      "ActionSetCommodity",
      "ActionSetAtmosferas",
      "ActionSetContenedores",
    ]),
    ...mapActions("lineas", [
      "actionSetDataListarTarifasAcuerdosLineas",
      "actionSetDataListarTarifasAcuerdosLineasInicial",
      "actionSetDataListaPOD",
      "actionSetDataListaPOL",
      "actionSetDataListaNaviera",
      "actionSetDataListaNavierasNoUCC",
      "actionSetDataListaProducto",
      "actionSetDataListaDestinos",
      "actionDataDatatableTarifasAcuerdosLineasFull",
      "actionSetSelectCommodities", "actionSetSelectAtmospheres", "actionSetSelectContainers"
    ]),
    ...mapActions("administracion", [
      "actionSetDataAtmosferas",
    ]),
    actualizarURL() {
      let me = this;
      me.AccionCambiar(this.$route.path);
    },
    async getListaAcuerdosLineas() {
      this.ActionSetLoading(true);
      const {
        data_table,
        filtros_pod,
        filtros_pol,
        filtros_navieras,
        filtros_navieras_no_ucc,
        filtros_commodity,
        filtros_destinos,
        filtros_atmosfera,
        filtros_atmosferas,
        filtros_containers
      } = await getAcuerdosLineas();
      this.fullData = data_table;
      this.actionDataDatatableTarifasAcuerdosLineasFull(data_table);
      this.actionSetDataListarTarifasAcuerdosLineas(data_table);
      this.actionSetDataListaPOD(filtros_pod);
      this.actionSetDataListaDestinos(filtros_destinos);
      this.ActionSetCommodity(filtros_commodity);
      this.actionSetDataListaPOL(filtros_pol);
      this.actionSetDataListaNaviera(filtros_navieras);
      this.actionSetDataListaNavierasNoUCC(filtros_navieras_no_ucc);
      this.actionSetDataAtmosferas(filtros_atmosfera);
      this.ActionSetAtmosferas(filtros_atmosferas);
      this.ActionSetContenedores(filtros_containers);
      const data = await getListasAcuerdosBase();
      this.actionSetSelectCommodities(data.lista_prod_categories);
      this.actionSetSelectAtmospheres(data.lista_atmosferas);
      this.actionSetSelectContainers(data.lista_contenedores);
      this.actualizarURL();
      this.ActionSetLoading(false);
    },
  },
  created() {
    this.getListaAcuerdosLineas();
  },
  watch: {
    dataDatatableTarifasAcuerdosLineas: function (_new) {
      if (_new) {
        this.data = _new;
      }
    },
  },
};
</script>
<style></style>
